import React from "react";

/**
 * Fundal fotografic cu cafea, diferit pe fiecare pagină.
 * - slot: home | writings | post | about | talk | questions (variabila CSS --bg-{slot}, suprascrisă din Personalizare)
 * - tone: "light" = voal lăptos (text închis deasupra); "dark" = voal negru-cafea (text deschis deasupra)
 */
const DEFAULT_FILES = { home: "home.jpg", writings: "gallery.jpg", post: "post.jpg", about: "about.jpg", talk: "talk.jpg", questions: "questions.jpg" };

export const CoffeeBackground = ({ slot = "post", tone = "light", testId = "coffee-bg" }) => {
  const fallback = `url("${process.env.PUBLIC_URL || ""}/backgrounds/${DEFAULT_FILES[slot] || "post.jpg"}")`;
  const veil =
    tone === "dark"
      ? "linear-gradient(180deg, rgba(20,16,13,0.78) 0%, rgba(20,16,13,0.62) 45%, rgba(20,16,13,0.86) 100%)"
      : "linear-gradient(180deg, color-mix(in srgb, var(--paper) 92%, transparent) 0%, color-mix(in srgb, var(--paper) 56%, transparent) 12%, color-mix(in srgb, var(--paper) 70%, transparent) 40%, color-mix(in srgb, var(--paper) 82%, transparent) 70%, color-mix(in srgb, var(--paper) 93%, transparent) 100%)";
  return (
    <div aria-hidden="true" data-testid={testId} className="pointer-events-none absolute inset-0 overflow-hidden">
      <div
        className="coffee-bg-photo absolute inset-0 bg-cover bg-center bg-no-repeat md:bg-fixed"
        style={{ backgroundImage: `var(--bg-${slot}, ${fallback})` }}
      />
      <div className="absolute inset-0" style={{ background: veil }} />
      <div className="grain absolute inset-0" />
    </div>
  );
};

export default CoffeeBackground;
